import { CREATE_EVENT, GET_USER_EVENTS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_USER_EVENTS}_SUCCESS`) {
    return action.payload.items;
  }

  if (action.type === `${CREATE_EVENT}_SUCCESS`) {
    state.push(action.payload);
    return state;
  }

  return state;
};
